import { render, staticRenderFns } from "./OrderAccountList.vue?vue&type=template&id=49dbbf7e&scoped=true&"
import script from "./OrderAccountList.vue?vue&type=script&lang=js&"
export * from "./OrderAccountList.vue?vue&type=script&lang=js&"
import style0 from "./OrderAccountList.vue?vue&type=style&index=0&id=49dbbf7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49dbbf7e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VPagination,VRow})
